import { createApi } from '@reduxjs/toolkit/query/react';
import PaginatedResult from '../../types/paginatedResult';
import { buildPaginatedQuery, safeBaseQuery } from './functions';
import { LanguageDto } from '../../types/language';

const language = createApi({
    reducerPath: 'apiLanguage',
    baseQuery: safeBaseQuery('language'),
    endpoints: (builder) => ({
        getAllLanguages: builder.query<LanguageDto, void>({
            query: () => `/all`,
        }),
        getLanguageById: builder.query<LanguageDto, number>({
            query: (id) => `/${id}`,
        }),
        getLanguages: builder.query<
            PaginatedResult<LanguageDto>,
            {
                page?: number;
                pageSize?: number;
                orderBy?: string;
                asc?: boolean;
            }
        >({
            query: (args = {}) => buildPaginatedQuery<Record<string, never>>(args),
        }),
    }),
});

export const { useGetLanguagesQuery, useLazyGetLanguageByIdQuery, useGetAllLanguagesQuery } = language;
export default language;
